import styled from 'styled-components'
import { media } from 'styles'
import Filters from 'components/Filters/StyledFilters'

const StyledBrowse = styled.section`
  ${Filters} {
    display: none;
    margin-bottom: 1rem;
    overflow-x: scroll;
  }

  ${media.mobile`
    margin-bottom: 3rem;
  `}
`

export default StyledBrowse
